<template>
   <div>
        <section class="community" :id="$t('routes.contact')">
            <div class="sloth-container">
                <div class="community-content">
                    <div class="community-item">
                        <div>
                            <img src="/assets/images/LogoSlothGrande.svg" width="200" alt="">
                            <h2 class="community-title">
                                {{ $t('contact.title')}}
                            </h2>
                            <p class="community-description">
                                {{$t('contact.description') }}
                            </p>
                        </div>
                        <div>
                            <div   v-bind:class="['alert', alertClass, showAlert? 'show': '']">
                            <span>{{$t(alertMessage)}}</span>
                                <button @click="showAlert = !showAlert" type="button" class="close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <form @submit.prevent="validateBeforeSubmit" id="contact-form">

                                <div class="form-contact">


                                    <div class="form-group">
                                        <label for="name" class="text-white">
                                            {{ $t('contact.name') }}
                                        </label>
                                        <input :disabled="sent" type="text" v-validate="'required'" name="name" id="name" class="form-input" v-model="contact.name" autocomplete="off">
                                        <span v-show="errors.has('name')" class="message-error">{{$t('error.name')}} </span>
                                    </div>
                                    <div class="form-group">
                                        <label for="email" class="text-white">
                                            {{ $t('contact.email') }}
                                        </label>
                                        <input :disabled="sent" v-validate="'required|email'" type="email" id="email" class="form-input"
                                            v-model="contact.to" name="email" autocomplete="off">
                                        <span v-show="errors.has('email')" class="message-error">{{$t('error.email')}} </span>
                                        
                                    </div>
                                    <div class="form-item">
                                        <label for="name" class="text-white">
                                            {{ $t('contact.phone') }}
                                        </label>
                                        <input :disabled="sent" class="form-input" type="tel" v-validate="'numeric'" v-model="contact.phone"
                                            name="tel" autocomplete="off">
                                        <span v-show="errors.has('tel')" class="message-error">
                                        {{$t('error.phone')}}
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <label for="message" class="text-white">
                                            {{ $t('contact.message') }}
                                        </label>
                                        <textarea :disabled="sent" class="form-input form-area" id="message" v-model="contact.body"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                     <vue-recaptcha
                                    ref="recaptcha"
                                    @verify="onVerify"
                                    @expired="onExpired"
                                    :sitekey="sitekey">
                                    </vue-recaptcha>
                                </div>
                           
                                <div class="form-group">
                                    <button type="submit" :disabled="errors.any() || formFilled || loading || sent || !captchaSolved" class="button button--cta button--white" style="width: 100%;">
                                        {{ $t('contact.submit') }}
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                    <div class="community-item">
                        <img class="community-image floating" style="margin: 0 auto;" src="/assets/images/community-connect.svg"
                            alt="">
                    </div>
                </div>
            </div>
        </section>
   </div>
</template>


<script>
import axios from "axios";
import VueRecaptcha from 'vue-recaptcha';
const sendMail = (contact) => {
    const url = process.env.VUE_APP_ROOT_API + "/sendcontactmail";
    const lang =  sessionStorage.getItem("lang");
    const data = {name: contact.name, to: contact.to, body:contact.body,phone:contact.phone, lang, captcha: contact.captcha};
    return axios.post(url, data,{headers:{
        'Content-Type': 'application/json',
        'X-Api-Key': process.env.VUE_APP_AK_API
    }});
}
const removeForm = () => {
    const elem = document.getElementById('contact-form');
    elem.parentNode.removeChild(elem);
    return false;
}
export default {
  name: "Contact",
  components: { VueRecaptcha },
  data() {
    return {
     formErrors: [],
     contact: {
          name: "",
          to: "",
          body: "",
          phone: "",
          captcha: ""
     },
      loading: false,
      sent: false,
      alertClass: '',
      showAlert: false,
      captchaSolved: false,
      alertMessage: '',
      sitekey: '6Le1sm8UAAAAAHazzbhgYpSa3wwAIRXpwb_12PyD'
    };
  },
  methods: {
    displayAlert(success) {
        this.showAlert = true;
        this.alertClass = success ? 'alert-info' : 'alert-error';
        this.alertMessage = success ? 'contact.success_message': 'contact.error_message';
    },
    validateBeforeSubmit() {
        this.$validator
        .validateAll()
        .then(() => {
          this.loading = true;
         sendMail(this.contact).then(res => {
                if(res.data && res.data.success) {
                    this.sent = true;
                    removeForm();
                    this.displayAlert(true);
                } else {
                     this.displayAlert(false);
                }
            }, () => {
                 this.displayAlert(false);
            });
             }).catch(() => {}); 
    },
    onVerify(response) {
        this.captchaSolved = response && response.length  > 10;
        this.contact.captcha = response;
    },
    onExpired(){
      this.contact = {
          name: "",
          to: "",
          body: "",
          phone: "",
          captcha: ""
     };
    },
  },
  computed: {
    formFilled() {
      return !(
        this.contact.name &&
        this.contact.to &&
        this.contact.body
      );
    }
  }
};
</script>